import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './Icon.pcss';

import {CustomPropShapes, CustomPropTypes, sizes, shapes} from '../../constants';
import {isSrc} from '../../utils/PropUtils';

class Icon extends PureComponent {
    static propTypes = {
        ariaLabel: PropTypes.string,
        backgroundColor: CustomPropTypes.color,
        className: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
        size: CustomPropShapes.oneOfConstant(sizes),
        icon: CustomPropTypes.icon.isRequired,
        style: PropTypes.object,
        type: PropTypes.oneOf([shapes.ROUND, shapes.SQUARE])
    };

    static defaultProps = {
        size: sizes.MEDIUM
    };

    renderIcon = () => {
        const {icon} = this.props;

        if (!icon) return null;

        if (isSrc(icon)) {
            return <span className={styles.bgImage} style={{backgroundImage: `url(${icon})`}} />;
        }
        const properties = {
            xmlns: 'http://www.w3.org/2000/svg',
            className: styles.svg
        };
        if (icon.viewBox) {
            properties.viewBox = icon.viewBox;
        }

        return <svg {...properties}>{icon.data}</svg>;
    };

    render() {
        const {ariaLabel, backgroundColor, className, size, style, type} = this.props;

        const wrapperClasses = cx(
            className,
            styles.wrapper,
            styles[size],
            type ? styles[type] : ''
        );

        const styleObj = backgroundColor ? {...style, backgroundColor} : style;

        return (
            <span
                aria-label={ariaLabel}
                className={wrapperClasses}
                style={styleObj}
                aria-hidden={true}>
                {this.renderIcon()}
            </span>
        );
    }
}

export default Icon;
